import './style.less';

export default function($log, $q, $stateParams, $state, Upload, ApiClass, ProfileClass, ResolveClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const profile_uid = $stateParams.employeeID || $stateParams.id;
  const manage = ResolveClass.isManageRoute();

  const { profile } = ProfileClass.profileComplete;

  vm.removePdf = () => {
    updateUploadStatus(false, '')
      .then(() => {
        vm.uploaded = false;
        vm.certificate.pdf_uploaded = false;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  function updateUploadStatus(pdf_uploaded, pdf) {
    return ApiClass.usersIdTypeTypeIdPatch(
      { id: profile_uid, type: 'certificates', type_id: $stateParams.certId, manage: false },
      { pdf, pdf_uploaded },
      {}
    );
  }

  function uploadFile(file, s3Policy) {
    return $q((resolve, reject) => {
      return Upload.upload({
        url: s3Policy.filePolicy.action,
        data: s3Policy.filePolicy.fields,
        file: file,
        method: 'POST',
        skipAuthorization: true
      })
        .then(
          function() {
            vm.pdfProgress = 'Uploaded';
            resolve('uploaded');
          },
          function(resp) {
            $log.error('Error status: ' + resp.status);
            throw new Error(`PDF UPLOADING ERROR ${$stateParams.id}`);
          },
          function(evt) {
            const pdfStaus = parseInt((100.0 * evt.loaded) / evt.total);
            vm.pdfProgress = `${pdfStaus}%`;
          }
        )
        .catch(error => reject(error));
    });
  }

  vm.uploadPdf = file => {
    if (!file) return;
    vm.pdfProgress = 'Uploading...';
    vm.certificate.pdf_uploaded = false;
    vm.uploadBtn = true;
    ApiClass.companiesIdTypePut(
      { manage, id: ProfileClass.company_id, type: 'policies' },
      {
        profile_uid,
        policy: 'certificate',
        cert_id: $stateParams.certId,
        file_type: file.type,
        file_name: file.name
      }
    )
      .then(({ data: { item: s3Policy } }) => {
        vm.s3Policy = s3Policy;
        return uploadFile(file, s3Policy);
      })
      .then(() => updateUploadStatus(true, vm.s3Policy.link))
      .then(() => {
        vm.certificate.pdf = `${vm.s3Policy.link}?time=${new Date().getTime()}`;
        vm.certificate.pdf_uploaded = true;
        vm.uploadBtn = false;
        vm.uploaded = true;
        vm.fileToUpload = false;
      })
      .catch(error => {
        vm.uploadBtn = false;
        vm.uploaded = false;
        vm.certificate.pdf_uploaded = false;
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    $log.debug('Users Certificate Upload Activated');
    vm.fileToUpload = false;
    vm.uploaded = false;

    vm.loaded = false;
    vm.error = {};

    ApiClass.usersIdTypeTypeIdGet({
      id: profile_uid,
      type: 'certificates',
      type_id: $stateParams.certId,
      manage: false
    })
      .then(({ data: { item: cert } }) => {
        if (cert.internal_pdf === true) return $state.go('app.users.certificates', $stateParams);

        cert.pdf = `${cert.pdf}?time=${new Date().getTime()}`;
        vm.certificate = cert;
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/certificates/upload/index.js